var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('VTable',{attrs:{"items":_vm.items,"headers":_vm.headers,"pagination":false,"editable":_vm.editable},on:{"edit":_vm.edit}})
}
var staticRenderFns = []

export { render, staticRenderFns }